import { Ptag } from "components/core/fonts";
import React from "react";
import {
  ECardDetailWrapper,
  ECardRightSection,
  ECardStrip,
  ECardWrapper,
  InsurerLogoWrapper,
} from "./styles";
import { formatDateReverse } from "utlis/utils";

const ECard = ({ member, noStrip }) => {
  function formatDate(date) {
    let new_date;
    new_date = date.split("-").join("/");
    return new_date;
  }
  // formatting relationship
  const formatRelationship = (text) => {
    let title = text;
    switch (text) {
      case "FATHERINLAW":
        title = "Father-in-Law";
        break;
      case "MOTHERINLAW":
        title = "Mother-in-Law";
        break;
    }
    return title.toLowerCase();
  };
  return (
    <ECardWrapper>
      {!noStrip && <ECardStrip />}
      <ECardDetailWrapper>
        <div>
          <Ptag fontSize="12px">Name</Ptag>
          <Ptag marginTop="6px" fontSize="16px">
            {member.name}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag
            marginBottom="4px"
            marginTop="6px"
            fontSize="10px"
            fontWeight="400"
          >
            ISSUED BY
          </Ptag>
          <InsurerLogoWrapper>
            <img src={member.insurer} alt="" />
          </InsurerLogoWrapper>
        </ECardRightSection>
        <div>
          <Ptag fontSize="12px" fontWeight="600">
            Policy Number
          </Ptag>
          <Ptag marginTop="6px" fontSize="16px">
            {member.policy_number}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag fontSize="12px" fontWeight="600">
            Unique Health ID
          </Ptag>
          <Ptag marginTop="6px" fontSize="16px">
            {member.client_id || "-"}
          </Ptag>
        </ECardRightSection>
        <div>
          <Ptag fontSize="12px" fontWeight="600">
            Date of Birth
          </Ptag>
          <Ptag marginTop="6px" fontSize="16px">
            {formatDate(member.dob)}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag fontSize="12px" fontWeight="600">
            Relationship
          </Ptag>
          <Ptag textTransform="capitalize" marginTop="6px" fontSize="16px">
            {formatRelationship(member.relationship)}
          </Ptag>
        </ECardRightSection>
        <div>
          <Ptag fontSize="12px">
            Cover Start Date
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {member.policy_start_date ? formatDateReverse(member.policy_start_date) : "-"}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag fontSize="12px">
            Cover End Date
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {member.policy_end_date ? formatDateReverse(member.policy_end_date) : "-"}
          </Ptag>
        </ECardRightSection>
      </ECardDetailWrapper>
    </ECardWrapper>
  );
};

export default ECard;
